<div
  class="message-row"
  [class.mine]="message().mine"
  [id]="'msg-' + message().id"
>
  <!-- Swipe-to-reply indicator (mobile) -->
  @if (isSwiping()) {
    <div
      class="swipe-reply-indicator"
      [class.mine]="message().mine"
      [style.opacity]="swipeIndicatorOpacity()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="9 17 4 12 9 7" />
        <path d="M20 18v-2a4 4 0 0 0-4-4H4" />
      </svg>
    </div>
  }

  <!-- Hover actions + bubble side-by-side -->
  <div
    class="message-bubble-wrap"
    [class.actions-open]="isMenuOpen()"
    [style.transform]="
      swipeOffset() !== 0 ? 'translateX(' + swipeOffset() + 'px)' : null
    "
    [style.transition]="
      isSwiping() ? 'none' : 'transform 0.25s cubic-bezier(0.25, 1, 0.5, 1)'
    "
    (click)="onBubbleClick($event)"
    (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd($event)"
  >
    <!-- Inline hover actions (appear beside bubble) -->
    <div class="msg-hover-actions">
      @if (message().mine) {
        <!-- My messages: Reply + Delete only -->
        <button
          type="button"
          class="msg-action-icon"
          title="Reply"
          aria-label="Reply"
          (click)="$event.stopPropagation(); setReply.emit(message())"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="9 17 4 12 9 7" />
            <path d="M20 18v-2a4 4 0 0 0-4-4H4" />
          </svg>
        </button>
        <button
          type="button"
          class="msg-action-icon unsend-icon"
          title="Unsend"
          aria-label="Unsend message"
          (click)="$event.stopPropagation(); unsend.emit(message().id)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="3 6 5 6 21 6" />
            <path
              d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
            />
          </svg>
        </button>
      } @else {
        <!-- Their messages: Reply + Emoji only -->
        <button
          type="button"
          class="msg-action-icon"
          title="Reply"
          aria-label="Reply"
          (click)="$event.stopPropagation(); setReply.emit(message())"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="9 17 4 12 9 7" />
            <path d="M20 18v-2a4 4 0 0 0-4-4H4" />
          </svg>
        </button>
        <div class="react-wrap">
          <button
            type="button"
            class="msg-action-icon"
            title="React"
            aria-label="React"
            (click)="toggleReactionPicker($event)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M8 14s1.5 2 4 2 4-2 4-2" />
              <line x1="9" y1="9" x2="9.01" y2="9" />
              <line x1="15" y1="9" x2="15.01" y2="9" />
            </svg>
          </button>

          @if (reactionPickerOpen()) {
            <div
              class="quick-reaction-picker"
              [style.bottom.px]="pickerBottom()"
              [style.left.px]="pickerLeft()"
              (click)="$event.stopPropagation()"
            >
              @for (emoji of quickEmojis; track emoji) {
                <button
                  type="button"
                  class="quick-emoji-btn"
                  [class.selected]="reactions().includes(emoji)"
                  (click)="toggleReaction(emoji, $event)"
                >
                  {{ emoji }}
                </button>
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- Bubble column: quote + bubble + reactions -->
    <div class="bubble-col">
      @if (message().replyTo) {
        <div
          class="reply-quote"
          (click)="scrollToReply.emit(message().replyTo!.id)"
        >
          <span>{{ message().replyTo!.text }}</span>
        </div>
      }
      @if (message().imageUrl && message().viewOnce && !message().mine) {
        <!-- View-once received: compact tap-to-view bubble -->
        <button
          type="button"
          class="vo-bubble vo-tap-btn"
          (click)="$event.stopPropagation(); onViewOnce()"
        >
          <div class="vo-row">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <path d="M21 15l-5-5L5 21" />
            </svg>
            <span class="vo-label">Tap to view photo</span>
            <span class="vo-chip">View once</span>
          </div>
          <div class="vo-time">{{ message().time }}</div>
        </button>
      } @else if (message().imageUrl && message().viewOnce && message().mine) {
        <!-- View-once sent: compact "Photo sent" bubble -->
        <div class="vo-bubble vo-sent-bubble">
          <div class="vo-row">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <path d="M21 15l-5-5L5 21" />
            </svg>
            <span class="vo-label">Photo sent</span>
            <span class="vo-chip">View once</span>
          </div>
          <div class="vo-time">{{ message().time }}</div>
        </div>
      } @else if (message().imageUrl) {
        <!-- Regular (non-view-once) image -->
        <div class="message-bubble image-bubble">
          <div class="chat-image-wrap">
            <img [src]="message().imageUrl" class="chat-image" alt="Photo" />
          </div>
          <small class="img-time">{{ message().time }}</small>
        </div>
      } @else {
        <div class="message-bubble">
          <span>{{ message().text }}</span>
          <small>{{ message().time }}</small>
        </div>
      }

      @if (reactions().length > 0) {
        <div class="reaction-badges">
          @for (emoji of reactions(); track emoji) {
            <button
              type="button"
              class="reaction-badge"
              (click)="toggleReaction(emoji, $event)"
            >
              {{ emoji }}
            </button>
          }
        </div>
      }
    </div>
  </div>
</div>

<!-- ── View-once fullscreen lightbox (fixed, escapes all layout) ───────────── -->
@if (lightboxOpen()) {
  <div class="vo-lightbox" (click)="closeLightbox()">
    <div class="vo-lightbox-inner" (click)="$event.stopPropagation()">
      <img [src]="message().imageUrl" class="vo-image" alt="Photo" />
      <div class="vo-bar">
        <div class="vo-progress-track">
          <div class="vo-progress-fill" [style.animation-duration]="'3s'"></div>
        </div>
        <span class="vo-hint">Disappears after viewing</span>
      </div>
    </div>
  </div>
}
